var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-col items-center justify-center border-2 border-dashed border-gray-300 text-gray-600 text-center rounded appearance-none"},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }